<template>
  <div class="py-3">
    <div class="row">
      <div v-if="loading" class="col-12 d-flex justify-content-center">
        <span
          class="text-center loadingres mr-1 ml-1 spinner-border loading-spinner"
        ></span>
      </div>

      <div class="col-sm-12" v-if="!loading">
        <div class="table-responsive">
          <div v-for="(parent, key) in parents" :key="key">
            <div class="pb-4 max-content table-sticky-1col">
              <h3 class="ml-3">{{ parent.parent_name }}</h3>
              <StatsTable
                :statsClient="statsClient[parent.parent_name]"
                :statsType="getStatsTypeByParent(parent.parent_name)"
                :statsDate="statsDate"
                :showTotal="
                  parent.parent_name == 'Deliverability tests' ? true : false
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { adminService } from "@/_services";
import StatsTable from "@/components/Usages/StatsTable.vue";

export default {
  props: {
    targetId: String,
  },
  components: {
    StatsTable,
  },
  data() {
    return {
      statsClient: {},

      statsType: {},
      statsDate: [],
      loading: true,

      diagnostic: [],
      parents: [],
      statsType: [
        // {
        //   id: "gmail_gmail",
        //   label: "gmail > gmail",
        //   format: "percentage",
        //   showQty: false,
        //   showTotal: false,
        //   parent: "sent",
        // },
      ],
    };
  },

  created() {
    adminService
      .getDeliverabilityByProviderHistory(this.targetId)
      .then((res) => {
        if (res["deliverabilityByProviderHistory"] !== null) {
          let statsX = this.formatData(
            res["deliverabilityByProviderHistory"],
            "deliver_prc",
            "Deliverability tests",
            "percentage"
          );
          let statsX2 = this.formatData(
            res["replyByProviderHistory"],
            "reply_rate",
            "Reply rates",
            "rate"
          );

          statsX2.forEach((item2) => {
            let item = statsX.find((item) => item.fdate == item2.fdate);
            if (item) {
              Object.assign(item, item2);
            } else {
              statsX.push(item2);
            }
          });

          statsX.forEach((item) => {
            const client_id = item.client_id ? item.client_id : 0;
            const client_name = item.client_name ? item.client_name : "";
            const fdate = item.fdate;

            if (!this.statsDate.find((field) => field.date == fdate)) {
              this.statsDate.push({ date: fdate });
            }

            this.statsType.forEach((statType) => {
              let type = statType.id + "_" + statType.format;
              let parent = statType.parent;

              if (!this.parents.find((field) => field.parent_name == parent)) {
                this.parents.push({ parent_name: parent });
              }

              if (this.statsClient[parent] == undefined) {
                this.statsClient[parent] = {};
              }
              if (this.statsClient[parent][client_id] == undefined) {
                this.statsClient[parent][client_id] = {};
                this.statsClient[parent][client_id]["name"] = client_name;
              }
              if (this.statsClient[parent][client_id][fdate] == undefined) {
                this.statsClient[parent][client_id][fdate] = item;
              }

              if (item[type] !== undefined && item[type] !== null) {
                if (this.statsClient[parent][client_id][type] === undefined) {
                  this.statsClient[parent][client_id][type] = 0;
                  this.statsClient[parent][client_id][type + "_total"] = 0;
                }
                this.statsClient[parent][client_id][type] += parseFloat(
                  item[type]
                );
                this.statsClient[parent][client_id][type + "_total"]++;
              }
            });
          });

          this.statsDate.sort((a, b) => a.date - b.date);

          this.statsType.forEach((statType) => {
            let type = statType.id + "_" + statType.format;
            let parent = statType.parent;
            if (["avg", "percentage", "rate"].includes(statType.format)) {
              // arreglar promedio

              this.statsClient[parent][0][type] =
                this.statsClient[parent][0][type] /
                this.statsClient[parent][0][type + "_total"];
            }
          });
        }

        this.loading = false;
      });
  },
  methods: {
    formatData(x, field_value, parent, format_type) {
      let statsX = [];
      x.forEach((item) => {
        const fdate = item.fdate;
        if (!statsX.find((field) => field.fdate == fdate)) {
          statsX.push({ fdate: fdate });
        }
        let statWeek = statsX.find((field) => field.fdate == fdate);
        let provider_from_to = item.provider_from_to;
        let key = field_value + "_" + provider_from_to;
        statWeek[key + "_" + format_type] = item[field_value];

        if (!this.statsType.find((field) => field.id == key)) {
          this.statsType.push({
            id: key,
            label: provider_from_to == "ALL_ALL" ? "Total" : provider_from_to
              .replace("_", " > ")
              .replaceAll("gmail", "GOOGLE")
              .replaceAll("ews", "OUTLOOK")
              .toUpperCase(),
            format: format_type,
            showQty: false,
            showTotal: true,
            parent: parent,
            className: provider_from_to == "ALL_ALL" ? "font-weight-bold": ""
          });
        }
      });
      return statsX;
    },
    getStatsTypeByParent(parent) {
      let x = this.statsType.filter((e) => e.parent === parent);

      const orderFrom = ["GOOGLE", "OUTLOOK", "DITTO", "EAS", "MICROSOFT"];
      const orderTo = ["GOOGLE", "OUTLOOK", "OTHERS"];

      let customOrder = [];
      orderFrom.forEach((from) => {
        orderTo.forEach((to) => {
          customOrder.push(from + " > " + to);
        });
      });

      const entries = Object.entries(x);

      entries.sort(([keyA, valueA], [keyB, valueB]) => {
        const indexA = customOrder.indexOf(valueA.label);
        const indexB = customOrder.indexOf(valueB.label);
        return (
          (indexA === -1 ? Infinity : indexA) -
          (indexB === -1 ? Infinity : indexB)
        );
      });

      return entries.map(([, value]) => value);
    },
    getRate(a, b) {
      if (b == 0) {
        return 0;
      } else {
        return (parseFloat(a) / parseFloat(b)) * 100;
      }
    },
  },
};
</script>